import { Link } from 'react-router-dom'
import './Footer.css'

export default function Footer() {
  return (
    <footer id="sobre">
      <div className="footer-inner">
        <div className="footer-top">
          <div className="footer-brand">
            <Link to="/" className="footer-logo">
              <div className="flex items-center justify-center h-8 w-8 rounded-lg bg-orken-accent text-[#0d1f12] text-xs font-extrabold">Ō</div>
              <div>
                <div className="footer-logo-text">Orken</div>
                <div style={{ fontSize: 10, color: 'var(--text-muted)' }}>Tecnologia</div>
              </div>
            </Link>
            <p className="footer-desc">
              Empresa de soluções digitais para as gestões pública e privada, levando resultados para uma melhor tomada de decisão.
            </p>
          </div>

          <div className="footer-col">
            <h6>Navegue</h6>
            <ul>
              <li><a href="#setores">Setor Público</a></li>
              <li><a href="#setores">Setor Privado</a></li>
              <li><a href="#sobre">Sobre nós</a></li>
              <li><a href="#contato">Contato</a></li>
            </ul>
          </div>

          <div className="footer-col">
            <h6>Contato</h6>
            <ul>
              <li><span className="contact-item">contato@orkentecnologia.com.br</span></li>
              <li><span className="contact-item">+55 (88) 98151-0879</span></li>
              <li><span className="contact-item">Brasil</span></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copy">© 2026 Orken. Todos os direitos reservados.</p>
          <p className="footer-tagline">Construído com tecnologia. Movido por resultados.</p>
        </div>
      </div>
    </footer>
  )
}
